module.exports = __webpack_public_path__ + "images/emoji/musical_score.51084f2daeb00a539981.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/musical_score.png
// module id = F4zJ
// module chunks = 24